import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { GetKpiSuccessResponse, KpiApi, KpiInfo } from '../axios/generated/kpiManage';
import { IError } from '../interfaces/IError';
import { IKpiRepository } from '../interfaces/IKpiRepository';
import { customAxiosInstance } from '../axios/axiosInstance';
import { axiosErrorHandler } from '../axios/axiosError';

/**
 * KPI API へのアクセスを提供するリポジトリ実装。
 */
export class KpiRepository implements IKpiRepository {
  /**
   * 条件に一致するKPI一覧を取得する。
   * @param metricType - 分析種別
   * @param dimensionTypes - 取得対象の切り口タイプ（カンマ区切り）
   */
  async get(metricType: string, dimensionTypes: string): Promise<INetworkResult<GetKpiSuccessResponse, IError>> {
    try {
      const axiosInstance = await customAxiosInstance('dbAccess');
      const kpiApi = new KpiApi(undefined, undefined, axiosInstance);

      const apiResponse = await kpiApi.getKpi(metricType, dimensionTypes);
      switch (apiResponse.status) {
        case 200:
          const result = apiResponse.data;
          return { status: { type: 'success', data: result } };
        default:
          new Error('想定外のレスポンス');
          return {
            status: {
              type: 'error',
              error: {
                statusCode: 0,
                code: '',
                message: '',
              },
            },
          };
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * KPIを登録する
   * @param request - 登録のリクエスト
   */
  async post(request: KpiInfo): Promise<INetworkResult<undefined, IError>> {
    try {
      const axiosInstance = await customAxiosInstance('dbAccess');
      const kpiApi = new KpiApi(undefined, undefined, axiosInstance);

      const apiResponse = await kpiApi.postKpi(request);
      switch (apiResponse.status) {
        case 200:
          const result = apiResponse.data;
          return { status: { type: 'success', data: undefined } };
        default:
          new Error('想定外のレスポンス');
          return {
            status: {
              type: 'error',
              error: {
                statusCode: 0,
                code: '',
                message: '',
              },
            },
          };
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
